import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(Backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    debug: true,
    lng: 'en',
    fallbackLng: 'en',
    // this makes sure that empty translations will fallback to english. This makes sure that if we deploy code
    // that has not been translated, it will show the english default instead of nothing.
    returnEmptyString: false,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    backend: {
      debug: true,
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  });

export function castAsString(record: Record<string, unknown>): string {
  return record as unknown as string;
}

export default i18n;
